module.exports = __webpack_public_path__ + "media/images/selectionBet__decoPickWinner-841ed2bf8e9e88e8bbf7b5b2b366ffc5.png";